// AI search isn't launching, so the form submits to the search page. To restore:
// export default function SearchCallout(el, {
//     actions,
//     events,
// }) {
//     const form = el.querySelector('form');
//
//     form.onsubmit = e => {
//         e.preventDefault();
//
//         events.emit(actions.askAiSearch, { q: form.q.value });
//     };
// }
export default function SearchCallout() {}
